var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{staticClass:"tw-w-full",class:{
    'skeleton tw-h-16 tw-w-36 tw-rounded-sm tw-bg-gray-100': _setup.loading,
    'error-label tw-h-16 tw-w-36 tw-rounded-sm tw-bg-red-200 tw-text-[0]':
      _setup.error,
  },attrs:{"src":"","alt":"Loading image..."},on:{"load":_setup.onLoad,"error":_setup.onError}})
}
var staticRenderFns = []

export { render, staticRenderFns }